import { render, staticRenderFns } from "./percurso.vue?vue&type=template&id=7343b843"
import script from "./percurso.vue?vue&type=script&lang=js"
export * from "./percurso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports